<template>
    <div id="PatientDocument">     
        <div class="row">
            <div class="col-12">
              <MdTitleRegInfo
                  v-bind:RegistrationInfo="PatientTitle" 
                  v-bind:titlePrefix="$tc('Shared.PatientDoc',2)" 
                  v-bind:IsClinical="IsClinical"
                  v-bind:titleRef="'titleElementPatientDocumentList'"
                  v-bind:patientCode="this.$route.params.id">
              </MdTitleRegInfo>

              <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
                <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                <div class="flex-grow-1">
                  <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                </div>
              </div>
            </div>
        </div>

        <div class="row">      
            <div class="col-sm-12 col-md-3" >                      
                <MdButton
                  v-bind:Label="$t('PatientDocument.AddDocument')" 
                  v-bind:ClassProp="this.isReadOnly? 'btn btn-primary my-3 btn-block' : 'btn btn-primary my-3 btn-block btn-login'"
                  v-on:click="AddDocument"
                  v-bind:IconClass="'ti-plus pr-1'"
                  v-bind:isReadOnly="this.isReadOnly"
                  v-bind:Name="'btn_add_document'">
                </MdButton>
            </div>              
            <div class="col-sm-12 col-md-9 mb-4">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input 
                          type="text" 
                          class="form-control"
                          :dir="dirInput"
                            v-model="parameter.SearchCriteria"
                            @keyup.enter="searchListing()"
                        >
                        <div class="input-group-append">
                              <MdButton
                              v-bind:Name="'btnsearchinput'"
                              v-bind:VariantProp="'btn btn-sm search-attached'"
                              v-bind:IconClass="'mdi mdi-magnify'"
                              v-on:click="searchListing()">
                            </MdButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>

       
        <div class="row">
          <b-col md="3" lg="3" sm="12">
              <!--<MdEdit 
                  v-bind:Label="$t('Shared.datefrom')"
                  v-bind:TypeProp="'date'" 
                  v-bind:Name="'DateFrom'"
                  v-model="DateFrom"
                  v-bind:Min="'1900-01-01'"
                  v-bind:Max="'2200-12-31'"                 
                  @input="DateFromChange"
                  v-bind:Id="'input_date_from'"
                  v-bind:OnPressEnter="SearchDocuments">                                     
              </MdEdit>-->
              <MdDateTime 
                  :Label="$t('Shared.datefrom')" 
                  :Model="DateFrom"                           
                  @input="DateFrom = $event"                            
                  :Id="'PatientDocumentListDateFrom'"
                  :Type="'date'"                  
                  :isRequired="false"  
                  :OnPressEnter="SearchDocuments"                         
                  :isConfirm="false"
                  :ReadOnly="false">
              </MdDateTime>
          </b-col>
          <b-col md="3" lg="3" sm="12">            
             <!--<MdEdit 
                v-bind:Label="$t('Shared.dateTo')"
                v-bind:TypeProp="'date'" 
                v-bind:Name="'dateto'"
                v-bind:Min="'1900-01-01'"
                v-bind:Max="'2200-12-31'"
                v-model="DateTo"              
                @input="DateToChange"
              v-bind:Id="'input_date_to'"
              v-bind:OnPressEnter="SearchDocuments"/>-->
              <MdDateTime 
                  :Label="$t('Shared.dateTo')" 
                  :Model="DateTo"                           
                  @input="DateTo = $event"                            
                  :Id="'PatientDocumentListDateTo'"
                  :Type="'date'"                  
                  :isRequired="false"  
                  :OnPressEnter="SearchDocuments"                         
                  :isConfirm="false"
                  :ReadOnly="false">
              </MdDateTime> 
          </b-col>
          <b-col md="3" lg="3" sm="12">
            <MdSelect
              v-bind:Label="$t('PatientDocument.DocumentType')"
              v-bind:Options="OptionDocumentTypes"
              v-bind:FieldDescription="'description'"
              v-bind:FieldCode="'code'"
              v-bind:Model="DocumentTypesVModel" 
              :Input="ChangeDropDownDocumentTypes"                      
              v-bind:Multiple="false"
              id="document_types_select"/>
          </b-col>
          <b-col md="3" lg="3" sm="12">    
            <MdSelect
              v-bind:Label="$t('PatientDocumentList.DocumentStatus')"
              v-bind:Options="OptionExpired"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'code'"
              v-bind:Model="ExpiredVModel"                       
              v-bind:Multiple="false"
              :Input="ChangeDropDownExpired"
              id="document_expired_select"
            /> 
          </b-col>
      </div>

      <b-row>
        <b-col md="12">
          <div class="text-center text-md-right mt-3">
            <button
              v-on:click="searchListing"
              type="button"
              class="btn btn-primary btn-login mx-2 pull-right"												
              id="btnsearchinput">
              {{ $t('Shared.Search') }}
            </button>
          </div>
        </b-col>
      </b-row>
       

       <!-- <LoadDocument v-bind:Records="this.files" />-->

       <div class="row">
        <div class="col-12">
            <div>
              <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
              <!--<div class="">
                <div class="row">
                  <div class="col-md-12">-->
                      <MdTable 
                        v-bind:fields="fields"
                        v-bind:items="items"
                        v-bind:totalRows="totalRows"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                        v-bind:currentPage="currentPage"
                        v-bind:perPage="perPage"
                        v-bind:pageOptions="pageOptions"
                        v-bind:refTable="'tablePatientDocument'"
                        v-bind:FieldsDate="FieldsDateArr"
                        :viewIconEvent="PatientDocumentView"                      
                        :editIconEvent="EditDocument"                        
                        v-bind:VisibleEditIcon="!this.isReadOnly"
                        :deleteIconEvent="DeleteDocument"
                        v-bind:VisibleDownloadIcon="true"
                        v-bind:IsDocumentManagement="true"
                        :downloadIconEvent="DownloadIcon"
                        v-bind:VisibleDeleteIcon="!this.isReadOnly"
                        :onRowSelected="onRowSelected"
                        :onFiltered="onFiltered"
                        :pageChanged="pageChanged"
                        :perPageFunction="PerPageFunction">
                      </MdTable>
                    <!--</div>
                  </div>
                </div> -->
            </div>
        </div>
    </div>

  <DxPoPup v-if="isVisible" 
    :Title="$tc('Shared.PatientDoc',2)"
    :closeWindow="closeRepWindow"
    :isVisible="isVisible"
    :Url="this.FullUrl"
  />

  <MdPasswordDlg v-if="showSignPassword" 
    v-bind:Type="TypePassWord"
    v-bind:VerificationType="'SupervisorPassword'"
    @getModalPassword="onModalPasswordResult($event)"
  />
    </div> 
</template>

<script>

import ShowMessage from "@/components/messages/ShowMessage.js";
import DBFunctions from '@/common/DBFunctions.js'
import EnumService from '@/services/enum.service'
import DocumentManagement from '@/services/documentmanagement.service'
import DocumentType from '@/services/documenttype.service'
import moment from 'moment'
import Utils from '@/common/utils'
import Permission from '@/common/Permission'

export default {
  /*beforeRouteEnter(to, from, next) {
        next(async vm => {
            const iPIn = await vm.$store.state.isUsePatientDocument;
            if(iPIn) next()
            else next('/accessdenied');
        }) 
  },*/
  name: 'PatientDocumentList',
  mixins: [ShowMessage, DBFunctions, Utils, Permission],
  data(){
    return{
      IsClinical:false,
      RegistrationInfo:{},
      infoList:[],
        DateFrom:null,
        DateTo:null,
        isReadOnly:false,
        UploadDate:null,
        files:[], 
        TypePassWord:'Sign',
        ClassExpired:'',
        UserIdSelected:'',
        Doc:{},
        Id:'',
        FullUrl:"",
        isVisible:false,
        showSignPassword:false,
        modalIdDocuments:"modalIdPatientDocument",   
        parameter:{
        SearchCriteria:'',
        PageNumber : 1,
        DocumentType:"",
        PageSize:0,
        Expired:1,
        Status: true,       
      },
      seqNo:0,
      FieldsDateArr:['scanneddate','expirationDate'],
        OptionDocumentTypes:[],
        ExpiredVModel:{code:1,name: this.$t('Shared.All')},
        IsExpired:false,
        OptionExpired:[{"code":1,"name": this.$t('Shared.All') },
                      {"code":2,"name":this.$t('Shared.Expired')},
                      {"code":3,"name":this.$t('PatientDocumentList.DocUnexpired')}],
        DocumentTypesVModel:{code:'All',description: this.$t('Shared.All')},
    PatientTitle:{      
       programName:'',
       fullName:'',
       admitDate:'',
       dischargeDate:'',
       dob:'',
       activitytypename:'',
        startdatetime:'',
        ageFormatted:''
     },
     fields:[        
         
        { key: 'description', sortable: true, label: this.$t('PatientDocument.DocumentType'), class: 'text-Left' },
        { key: 'seqno', sortable: true, label: 'seqno', class: 'text-rigth hidden' },
        { key: 'scanneddate', sortable: true, label: this.$t('HouseFile.FileDate'), class: 'text-center' },
        { key: 'expirationDateDocument', sortable: true, label: this.$t('Shared.ExpirationDate'), class: 'text-center'},
        { key: 'comments', sortable: true, label: this.$t('Shared.Comments'), class: 'text-Left' },
       /* { key: 'sysUser', sortable: true, label: 'User', class: 'text-rigth' },*/
        { key: 'fileName', sortable: true, label: this.$t('HouseFile.FileName'), class: 'text-Left' },

     ],
     items:[],
     pageOptions: [5, 10, 15 ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
     ShowMessageIsEmpty:false,
     OptionsRightMenu:{
            visible:true,
            ItemsList:[],
            btnvisible:true,
            itemdisabled: false,
            PatientCode:''         
        },
      currentAppointmentDB:{
          guid:'',
          activitytypecode:'',
          employee:{
          firstname:"",
              lastname:""
          }
      },
      dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',  
    }
  },
  methods:{

    DocumentExpired(value){ 
      if(value !== null && value !== '' && value !== undefined){
        if(Utils.ValidateDate(value)){
          let exp = moment.utc(value);
          let now = moment().utc();
          if(now.isAfter(exp)){           
            return true;
          }else{           
            return false;
          }
        }
      }     
      return false;      
    },

    onModalPasswordResult(result){      
      if(result.Event === 'Ok'){   
        if(result.status === true) {
         this.$emit('load', true);  
         if(this.Id){
         DocumentManagement.delete(this.Id)
                .then(() => {
                  const index = this.items.findIndex(item => item.seqno === this.Id) 
                  if (~index) {                   
                    this.items.splice(index, 1);                   
                  }
                  this.getDocuments(); 
                  this.$emit('load', false);  
                })
                .catch((error) => {
                  this.$emit('load', false);  
                    if(error.response.status === 400 ){
                     this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }else{
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                     }               
                });
        }
      }else{
        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.InvalidSupervisorPass'),"error");
      }
    }
     /* if(result.type === 'Sign'){
          if(result.status !== true) {
            this.showMessage(this.$tc('Msg.Error'),result.message,"error");
            this.Header.isSigned = false;
            this.$set(this.DataNote.Header, 'Issigned', false);
          }else{
            this.Header.isSigned = true;
            this.$set(this.DataNote.Header, 'Issigned', true);
          }
        }

         if(result.type === 'Cosign'){
          if(result.status !== true) {
            this.showMessage(this.$tc('Msg.Error'),result.message,"error");
            this.Header.isCoSigned = false;
            this.$set(this.DataNote.Header, 'IsCoSigned', false);
          }else{
            this.Header.isCoSigned = true;
            this.$set(this.DataNote.Header, 'IsCoSigned', true);
          }
        }

        this.showSignPassword = false;*/
        this.showSignPassword = false;
    },

    closeRepWindow() {
        this.isVisible = false;
      },

    DateFromChange(e){
        this.DateFrom = e;
        //this.getDocuments();  
    },
    DateToChange(e){
        this.DateTo = e;
       // this.getDocuments();  
    },

    ChangeDropDownDocumentTypes(t){
        this.DocumentTypesVModel = t ? t : {code:'',description:''}; 
        this.getDocuments();        
    },

    ChangeDropDownExpired(e){
        this.ExpiredVModel = e ? e : {code:1,name:'All'};
        this.getDocuments();
    },
    searchListing(){
        this.currentPage = 1;
        this.getDocuments();
    },

    SearchDocuments(){
        this.getDocuments();
    },

    async Download(url, filename) {          
           const data = await fetch(url)
           const blob = await data.blob()
           const objectUrl = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.setAttribute('href', objectUrl)
          link.setAttribute('download', filename)
          link.style.display = 'none'
          document.body.appendChild(link)                          
          link.click()                          
          document.body.removeChild(link)
      },

    VerifyExtension(ext){
      if(ext){
        if(ext.toLowerCase() === ".pdf" || ext.toLowerCase() === ".jpeg" ||
       ext.toLowerCase() === ".jpg" || ext.toLowerCase() === ".png" || 
       ext.toLowerCase() === ".bmp" || ext.toLowerCase() === ".svg" ||
       ext.toLowerCase() === ".gif" || ext.toLowerCase() === ".eps"){
        return true;
       }
       return false;
      }
      return false;
    },

    PatientDocumentView(row){     
      this.seqNo = row.seqno;       
      var baseurl = this.$store.state.apiurl.replace('/api/', '');      
        this.$emit('load', true);           
        DocumentManagement.GetPatientUrl(this.seqNo)
      .then((response) => {
        if(response.status == '200'){           
          this.Doc = response.data;  
          this.FullUrl = baseurl+response.data.url;  

          if(this.VerifyExtension(this.Doc.extension)){
            this.isVisible = true;
          }
          else{          
            this.Download(this.FullUrl,row.fileName);
            this.Load = false;         
          }
                 
        }
        this.$emit('load', false);
   
      })
      .catch(error => {
        /*if (!error.response) {                      
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    }                      
                    else if(error.response.status === 400 ){
                      this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                    } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     } */
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
      });
  
 

    },

    EditDocument(row){
      this.seqNo = row.seqno;      
      this.Mode = "Edit";
      if(this.$route.name.includes('patient')){   
        this.$router.push({ name: "patient-document-detail", params: { seqNo: this.seqNo } });
      }
      else if(this.$route.name.includes('appointments-document')){   
        this.$router.push({ name: "appointmentDB-document-detail", params: { id: this.$route.params.id, seqNo: this.seqNo, actId: this.$route.params.actId } });
      }
      else{		
        this.$router.push({ name: "Clinical-document-detail", params: { id: this.$route.params.id,seqNo: this.seqNo,recordid:this.$route.params.recordid } });       
      }
      
    },

    DeleteDocument(row){
      this.Id = row.seqno;     
           this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$t('PatientDocumentList.DeleteDocument'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
          id: 'modal_delete_document'
				})
          .then(value => {
            if(value){             
              this.showSignPassword = true;        
            }
          }) 
    },

    DownloadIcon(row){    
      this.getDocument(row);
    },

    getDocument(row) {
        this.$emit('load', true);
        var baseurl = this.$store.state.apiurl.replace('/api/', '');             
        DocumentManagement.GetPatientUrl(row.seqno)
      .then((response) => {
        if(response.status == '200'){ 
        this.FullUrl = baseurl+response.data.url;   
        this.Download(this.FullUrl,row.fileName);  
        this.Load = false;         
       }
        this.$emit('load', false);
   
      })
      .catch(error => {
        /*if (!error.response) {                      
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    }                      
                    else if(error.response.status === 400 ){
                      this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                    } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     } */
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
      });   
    },

    onRowSelected(){

    },

    onFiltered(){

    },

    pageChanged (page) {            
      this.currentPage = page; 
      this.parameter.PageNumber = this.currentPage;     
      this.getDocuments();
    },

    PerPageFunction(perpage){
      this.perPage = perpage;    
      this.parameter.PageNumber = 1;
      this.getDocuments();
    },

    AddDocument(){
      this.Mode = "Add";
       if(this.$route.name.includes('patient-document')){   
          this.$router.push({ name: "patient-document-add", params: { id: this.$route.params.id } });
       }
       else if(this.$route.name.includes('appointments-document')){   
        this.$router.push({ name: "appointmentDB-document-add", params: { id: this.$route.params.id, actId: this.$route.params.actId } });
        }
       else{		
          this.$router.push({ name: "Clinical-document-add", params: { id: this.$route.params.id,recordid:this.$route.params.recordid } });       
        }
      
    },

    async GetPatientByCode(){
      this.infoList = await this.getInfoTitle(this.$route.params.id);
      if(this.infoList.length > 0){
        this.PatientTitle.programName = '';
        this.PatientTitle.admitDate = '';
        this.PatientTitle.dischargeDate = '';

        const { dob, firstname, lastname, age, ageFormatted } = this.infoList[0]; // Destructure for easier access

        if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
        if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
        if (age) this.PatientTitle.age = age;
        if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;            
      }
    },

    getDocuments() {   
        this.$emit('load', true);
        this.parameter.EntityCode = this.$route.params.id; 
        this.parameter.Expired = this.ExpiredVModel.code;

        this.parameter.DocumentType = this.DocumentTypesVModel.code === 'All' ? '' : this.DocumentTypesVModel.code;
        this.parameter.DateFrom = this.DateFrom; //2022-10-25T11:53:30.407
        this.parameter.DateTo = this.DateTo; 
        this.parameter.PageSize = this.perPage;
        DocumentManagement.getAll(this.parameter)
      .then((response) => {
        if(response.status == '200'){
         this.items = response.data;   
         
         this.items.forEach(function(element) {
                          if (element.scanneddate)	
                              element.scanneddate = Utils.formatterDateTimeToString(element.scanneddate);
                          if (element.expirationDateDocument)	
                              element.expirationDateDocument = Utils.formatterDateToString(element.expirationDateDocument);


                        //  element.expired = this.DocumentExpired(element.expirationDate);    
                          if(element.expirationDateDocument !== null && element.expirationDateDocument !== '' && element.expirationDateDocument !== undefined){
                            if(Utils.ValidateDate(element.expirationDateDocument, Utils.getShortDateFormat())){
                              let exp = moment(element.expirationDateDocument, Utils.getShortDateFormat());
                              let now = moment();
                                if(now.isAfter(exp)){
                                  element.expired = "Document Expired";
                                }else{
                                  element.expired = "Document Not Expired";
                                }
                            }
                          }
                              
                        });
         
         let headerString = response.headers["x-pagination"];
         this.Header = JSON.parse(headerString);
         this.totalRows = this.Header.TotalCount;
         this.$emit('load', false);
         if(this.items.length === 0){
          this.ShowMessageIsEmpty = true;
        } 
        }
   
      })
      .catch(error => {
        /*if (!error.response) {                     
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    }                      
                    else if(error.response.status === 400 ){
                      this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                    } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     } */
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
      });
    },

    getDocumentTypes() {   
        this.$emit('load', true);           
        DocumentType.getAll(this.parameter)
      .then((response) => {
        if(response.status == '200'){           
         this.OptionDocumentTypes = response.data;        
         this.OptionDocumentTypes.unshift({code:'All',description: this.$t('Shared.All')});  
         this.$emit('load', false);
        }
   
      })
      .catch(error => {
        /*if (!error.response) {                     
                      this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                    }                      
                    else if(error.response.status === 400 ){
                      this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                    } else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     } */
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
      });
    },
    PopulatePatientTitle(){
      const { dob, dateFrom, dateTo, age, 
                programName, patientName, ageFormatted } = this.RegistrationInfo; // Destructure for easier access
        
      if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
      if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);	

      if(this.$route.name.includes('Clinical-document')){ 
        if (programName) this.PatientTitle.programName = programName; 
        if (dateFrom) this.PatientTitle.dateFrom = this.RegistrationInfo.dateFrom;
        if (dateTo) this.PatientTitle.dateTo = this.RegistrationInfo.dateTo;
        if (patientName) this.PatientTitle.fullName = patientName;
        if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
        if (age) this.PatientTitle.age = age === 0 ? "0" : age;
        if (ageFormatted) this.PatientTitle.ageFormatted = this.RegistrationInfo.ageFormatted;
      }
      if(this.$route.name.includes('patient-document') || this.$route.name.includes('appointments-document')){         
          this.PatientTitle.programName = '';
          this.PatientTitle.dateFrom = '';
          this.PatientTitle.dateTo = '';

          if(this.infoList.length > 0){
            const { dob, firstname, lastname } = this.infoList[0]; // Destructure for easier access
            if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
            if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;            
          }   
      }
    },
    async getCurrentAppointment() {
      this.currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
      this.PatientTitle.activitytypename  = this.currentAppointmentDB.activitytypename
      this.PatientTitle.startdatetime = `${Utils.formatterDateToString(this.currentAppointmentDB.transdate)} ${this.currentAppointmentDB.timein}`  
    }
  },
  async mounted(){
    this.OptionsRightMenu.visible = true;   
    this.OptionsRightMenu.ItemsList = this.$route.name.includes('Clinical-document') ? EnumService.ClinicalItems : this.$route.name.includes('appointments-document') ? EnumService.AppointmentItems : EnumService.PatientItems;
    this.$emit("getVisibleMenu", this.OptionsRightMenu); 

    this.isReadOnly = await this.$store.state.isPatientDocumentEHRReadOnly;    
    this.OptionsRightMenu.Mode = true; 

    if(this.$route.name.includes('patient-document') || this.$route.name.includes('appointments-document')){  
        this.GetPatientByCode();
    } 

    if(this.$route.name.includes('Clinical-document')){      
        this.RegistrationInfo = await this.getRegistrationInfoTitle(this.$route.params.recordid);
        const { dateTo, age } = this.RegistrationInfo; // Destructure for easier access

        this.IsClinical = dateTo ? false : true;
        if (age) this.RegistrationInfo.age = age === 0 ? "0" : age;
    }

    this.PopulatePatientTitle();
    if (this.$route.name.includes('appointments-document'))
      await this.getCurrentAppointment()

    this.getDocumentTypes();   
    this.getDocuments();
  },
};
</script>



